var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "item pb-3 mb-5 border-bottom",
      attrs: { id: "national_service--" + _vm.element.id }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 col-lg-4 mb-3 text-center position-relative" },
          [
            _vm.element.isSelected
              ? _c("badge", { staticClass: "position-absolute selected-badge" })
              : _vm._e(),
            _vm._v(" "),
            _c("img", {
              staticClass: "mw-100 position-relative image",
              attrs: { src: _vm.imagePath, alt: "" }
            }),
            _vm._v(" "),
            _vm.iconPath
              ? _c("img", {
                  staticClass: "position-absolute wholesaler__logo",
                  attrs: { src: _vm.iconPath, alt: "" }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-lg-8" }, [
          _vm.element.name
            ? _c("h2", { staticClass: "col-12" }, [
                _vm._v(_vm._s(_vm.element.name))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isLabel !== null
            ? _c("p", { staticClass: "col-12" }, [
                _c("span", { staticClass: "badge badge-secondary" }, [
                  _vm._v(_vm._s(_vm.isLabel))
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.element.description
            ? _c("div", {
                staticClass: "col-12",
                domProps: { innerHTML: _vm._s(_vm.element.description) }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 d-flex flex-row justify-content-end" },
            [
              _c(
                "div",
                { staticClass: "btn-group mt-3", attrs: { role: "group" } },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-success",
                      attrs: {
                        disabled: _vm.element.isSelected || _vm.syncingData,
                        type: "button"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toggleService(_vm.element, "activate")
                        }
                      }
                    },
                    [
                      _vm._v("Aktivieren "),
                      !_vm.syncingData
                        ? _c("i", { staticClass: "fas fa-plus" })
                        : _vm._e(),
                      _vm.syncingData
                        ? _c("i", { staticClass: "fas fa-spinner fa-spin" })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-danger",
                      attrs: {
                        disabled: !_vm.element.isSelected || _vm.syncingData,
                        type: "button"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toggleService(_vm.element, "deactivate")
                        }
                      }
                    },
                    [
                      _vm._v("Deaktivieren "),
                      !_vm.syncingData
                        ? _c("i", { staticClass: "fas fa-minus" })
                        : _vm._e(),
                      _vm.syncingData
                        ? _c("i", { staticClass: "fas fa-spinner fa-spin" })
                        : _vm._e()
                    ]
                  )
                ]
              )
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }